import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApiMiddlewarePayload } from '@ocean/api'
import { createApiAction } from 'api'
import { userLoggedOut } from 'core/session/slices/session'
import { getCourseDetails } from 'modules/activityDetails/CourseDetails/api/courseDetailsService'
import { CourseDetailsState, ApiCourseDetailsResponse } from './types'

const initialState: CourseDetailsState = {
  courseDetailsData: {},
}

const courseDetailsSlice = createSlice({
  name: 'courseDetails',
  initialState,
  reducers: {
    courseDetailsLoaded(
      state,
      action: PayloadAction<ApiMiddlewarePayload<ApiCourseDetailsResponse>>
    ) {
      state.courseDetailsData = action.payload
    },
    clearCourseDetails(state) {
      state.courseDetailsData = initialState.courseDetailsData
    },
  },
  extraReducers: builder => {
    builder.addCase(userLoggedOut, () => {
      return initialState
    })
  },
})

const { courseDetailsLoaded, clearCourseDetails } = courseDetailsSlice.actions

export { clearCourseDetails }
export default courseDetailsSlice.reducer

export const loadCourseDetailsData = (courseId: Guid, resultId?: Guid) => {
  return createApiAction({
    apiCalls: {
      courseDetails: () => getCourseDetails(courseId, resultId),
    },
    payloadAction: courseDetailsLoaded,
    getResultToKeep: state => state.courseDetails.courseDetailsData.result,
  })
}
